import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Rental from './pages/Consumer';
import Professional from './pages/Professional';
import Contact from './pages/Contact';
import Catalog from './pages/Catalog';
import About from './pages/About';
import ProductDetail from './pages/ProductDetail';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rental" element={<Rental />} />
            <Route path="/consumer" element={<Rental />} />
            <Route path="/professional" element={<Professional />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/company" element={<About />} />
            <Route path="/about/sustainability" element={<About />} />
            <Route path="/about/career" element={<About />} />
            <Route path="/products/:productId" element={<ProductDetail />} />
            <Route path="/solutions" element={<Professional />} />
            <Route path="/service" element={<Contact />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <Toaster />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
